import React from 'react';
import {injectIntl} from "react-intl";
import UploadPictures from "../../../common/upload/UploadPictures";
import SAInputComponent from "../../../common/input/SAInputComponent";
import SATextAreaLabel from "../../../common/input/SATextAreaLabel";

const MAX_DAMAGE_ATTACHMENTS = 10;

class CarDamageModification extends React.Component {

  render() {
    const {intl: {formatMessage}, vehicle, attachments, error = {}} = this.props;
    const {onInputTextChange, handleBeforeUpload, handleAttachmentsChange, handleFileRemove} = this.props;

    return (
      <div>
        <h3 className="box__subtitle">{formatMessage({id: 'car-information.damage.title'})}</h3>
        <div className="row">
          <ul className="list col-md-12 col-xxl-12">
            <li>
              <SATextAreaLabel label={formatMessage({id: 'vehicle.damage-description'})} onChange={onInputTextChange}
                               value={vehicle.advisorComment} name="advisorComment" autosize={true}/>
            </li>
            <li>
              <SAInputComponent label={formatMessage({id: 'vehicle.damage-pictures'})} error={error.reports}>
                <UploadPictures files={attachments}
                                showUploadList={{showPreviewIcon: false}}
                                beforeUpload={(file) => handleBeforeUpload(file, 'attachments')}
                                onChange={handleAttachmentsChange}
                                onRemove={(e) => handleFileRemove(e, 'attachments')}
                                allowUpload={attachments.length < MAX_DAMAGE_ATTACHMENTS}/>
              </SAInputComponent>
            </li>
          </ul>
        </div>
      </div>
    )
  }
}

export default injectIntl(CarDamageModification);
